import generalGetters from './getterTypes'

const getters = {
  [generalGetters.GET_API_VERSION]: state => state.apiVersion,
  [generalGetters.GET_PERMISSIONS]: state => state.permissions,
  [generalGetters.GET_FIELDS_DEFINITIONS]: state => state.fields,
  [generalGetters.GET_SIDEBAR_STATE]: state => state.isSidebarToggled,
  [generalGetters.GET_ALERT_MESSAGE]: state => state.alertMessage,
  [generalGetters.GET_ALERT_TYPE]: state => state.alertType,
  [generalGetters.GET_ERROR]: state => state.error,
  [generalGetters.GET_MOBILE_SIDEBAR_STATE]: state => state.isMobileSidebarToggled,
  [generalGetters.GET_LOADING]: state => state.loading
}

export default {
  ...getters
}
